import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getValueOrDash } from 'utils/data';
import { formatDateValue } from 'utils/format';

import { formatMoney, getNetDisbursement } from '../../../Construction.utils';
import {
  netCellValueStyles,
  requestedByStyles,
  sectionStyles,
  sectionTitleStyles,
  summaryCellStyles,
  summaryGridStyles,
} from '../../DrawReviewDrawer.styles';
import { DrawReviewDrawerTestIds } from '../../DrawReviewDrawer.testIds';

const DrawSummarySection = ({ drawRequest }) => {
  const netDisbursement = getNetDisbursement(drawRequest);
  const requestedDate = getValueOrDash(formatDateValue(drawRequest.requestDate));

  return (
    <Box data-testid={DrawReviewDrawerTestIds.SUMMARY_SECTION} sx={sectionStyles}>
      <Typography sx={sectionTitleStyles} variant="bold12">
        Draw Summary
      </Typography>
      <Box sx={summaryGridStyles}>
        <Box sx={summaryCellStyles}>
          <Typography color="text.secondary" variant="regular12">
            Requested
          </Typography>
          <Typography variant="medium16">{formatMoney(drawRequest.requested)}</Typography>
        </Box>
        <Box sx={summaryCellStyles}>
          <Typography color="text.secondary" variant="regular12">
            Retainage Held
          </Typography>
          <Typography variant="medium16">{formatMoney(drawRequest.retainageHeld)}</Typography>
        </Box>
        <Box sx={summaryCellStyles}>
          <Typography color="text.secondary" variant="regular12">
            Net to Disburse
          </Typography>
          <Typography sx={netCellValueStyles} variant="medium16">
            {formatMoney(netDisbursement)}
          </Typography>
        </Box>
        <Box sx={summaryCellStyles}>
          <Typography color="text.secondary" variant="regular12">
            Prior Draws Funded
          </Typography>
          <Typography variant="medium16">{formatMoney(drawRequest.priorDrawsFunded)}</Typography>
        </Box>
      </Box>
      <Box sx={requestedByStyles}>
        <Typography color="text.secondary" variant="regular14">
          Requested by
        </Typography>
        <Typography variant="medium14">{getValueOrDash(drawRequest.builderName)}</Typography>
        <Typography color="text.secondary" variant="regular14">
          on
        </Typography>
        <Typography variant="medium14">{requestedDate}</Typography>
      </Box>
    </Box>
  );
};

DrawSummarySection.propTypes = {
  drawRequest: PropTypes.object.isRequired,
};

export default memo(DrawSummarySection);
